module.exports = __webpack_public_path__ + "static/media/pooltogether-icon@2x.89d578d6.png";